<template>
  <div class="side-border-container">
    <div class="top"></div>
    <div class="middle"></div>
    <div class="bottom"></div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.side-border-container {
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  z-index: 1;
  .top {
    width: 100%;
    height: 39px;
    background: url('~@/assets/images/home-side-top.png');
  }
  .middle {
    flex: 1;
    width: 100%;
    background: url('~@/assets/images/home-side-middle.png');
  }
  .bottom {
    width: 100%;
    height: 28px;
    background: url('~@/assets/images/home-side-bottom.png');
  }
}
</style>